import { PromotionRepository } from '../../domain/repositories/promotion.repository';
import { PromotionEntity } from '../../domain/entities/promotion.entity';

export class TogglePromotionStatusUseCase {
  constructor(private readonly promotionRepository: PromotionRepository) {}

  async execute(id: string, status: boolean): Promise<PromotionEntity> {
    return this.promotionRepository.togglePromotionStatus(id, status);
  }
}
